import React from 'react'
import InputCustom from '../../../../components/elements/InputCustom'
import SelectDropDown from '../../../../components/elements/SelectDropDown'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import { AbstructLang } from '../../../../components/general/general-component/abstruct-component/AbstructLang';

function TopInputs({ order,state, setStateCustom,fakData }) {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang();
    return (
        <div className='d-flex'>
            <div className={`${langLocal === 'ar'? "margin_left_10": "margin_right_10"} one-select w-24`} >
                <span>{translate('requester')}</span>
                <SelectDropDown
                    options={[{ value: '1', label: "Requester 1" }, { value: '2', label: "Requester 2" }]}
                    varr={state.requester_id}
                    defaultvalue={{ value: fakData?.requester?.value, label: fakData?.requester?.label }}
                    setStateCustom={setStateCustom}
                    disable={order? true: false }
                />
            </div>
            <div className='w-25' >
                {/*fakData?.request_date = 02/13/2024*/}
                <InputCustom
                    label='request_date'
                    iconType='calendar'
                    type='date'
                    value={fakData?.request_date}
                    onChange={(e) => setStateCustom('request_date', e.target.value)}
                    disable={order? true: false }
                />
            </div>
            <div className='w-25' >
                <InputCustom
                    label='needed_on'
                    iconType='calendar'
                    type='date'
                    value={fakData?.needed_on}
                    onChange={(e) => setStateCustom('needed_on', e.target.value)}
                    disable={order? true: false }
                />
            </div>
            <div  className={`${langLocal === 'ar'? "margin_left_10": "margin_right_10"} one-select w-24`} >
                <span>{translate('warehouse')}</span>
                <SelectDropDown
                    options={[{ value: '1', label: "Warehouse 1" }, { value: '2', label: "Warehouse 2" }]}
                    varr={state.warehouse_id}
                    defaultvalue={{ value: fakData?.Warehouse?.value, label: fakData?.Warehouse?.label }}
                    setStateCustom={setStateCustom}
                    disable={order? true: false }
                />
            </div>
            <div  className={`${langLocal === 'ar'? "margin_left_10": "margin_right_10"} one-select w-24`} >
                <span>{translate('received_by')}</span>
                <SelectDropDown
                    options={[{ value: '1', label: "person 1" }, { value: '2', label: "person 2" }]}
                    varr={state.received_by}
                    defaultvalue={{ value: fakData?.received_by?.value, label: fakData?.received_by?.label }}
                    setStateCustom={setStateCustom}
                    disable={order? true: false }
                />
            </div>
            <div className='w-25' >
                <InputCustom
                    label='phone_number'
                    iconType='phone'
                    type='number'
                    value={fakData?.phone_number}
                    onChange={(e) => setStateCustom('phone_number', e.target.value)}
                    disable={order? true: false }
                />
            </div>
            <div  className={`${langLocal === 'ar'? "margin_left_10": "margin_right_10"} one-select w-24`} >
                <span>{translate('company_project')}</span>
                <SelectDropDown
                    options={[{ value: '1', label: "Company 1" }, { value: '2', label: "Company 2" }]}
                    varr={state.company_project_id}
                    defaultvalue={{ value: fakData?.company_project?.value, label: fakData?.company_project?.label }}
                    setStateCustom={setStateCustom}
                    disable={order? true: false }
                />
            </div>
            <div  className={`${langLocal === 'ar'? "margin_left_10": "margin_right_10"} one-select w-24`} >
                <span>{translate('status')}</span>
                <SelectDropDown
                    options={[{ value: '1', label: "Status 1" }, { value: '2', label: "Status 2" }]}
                    varr={state.status}
                    defaultvalue={{ value: fakData?.status?.value, label: fakData?.status?.label }}
                    setStateCustom={setStateCustom}
                    disable={order? true: false }
                />
            </div>
            <div className='w-25' >
                <InputCustom
                    label='request_number'
                    iconType='pencil'
                    value={fakData?.request_number}
                    type='number'
                    onChange={(e) => setStateCustom('request_number', e.target.value)}
                    disable={order? true: false }
                />
            </div>
            <div className='w-25' >
                <InputCustom
                    label='ship_to'
                    iconType='pencil'
                    value={fakData?.ship_to}
                    type='text'
                    onChange={(e) => setStateCustom('ship_to', e.target.value)}
                    disable={order? true: false }
                />
            </div>
            <div className='w-25' >
                <InputCustom
                    label='location'
                    iconType='pencil'
                    value={fakData?.location}
                    type='text'
                    onChange={(e) => setStateCustom('location', e.target.value)}
                    disable={order? true: false }
                />
            </div>
            <div style={order ? {width: '100%'}:{width: '25%'}} >
                <InputCustom
                    label='notes'
                    iconType='book'
                    value={fakData?.notes}
                    type='text'
                    onChange={(e) => setStateCustom('notes', e.target.value)}
                />
            </div>
        </div>
    )
}

export default TopInputs